import React, { useState } from 'react';
import { Box, Typography, Button, Stack, Divider } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { ViewButton } from '../../../../../components/mui/Buttons/Buttons';
import GlobalDialog from '../../../../../components/mui/Dialogue/GlobalDialog';

const StudentPortal = ({ crm, data }) => {
  const [open, setOpen] = useState(false);

  const portalLink = 'https://student.intervaledu.com'; // change if needed
  const username = data?.student_name || '';
  const password = `${data?.student_name || ''}@${data?.admn_no || ''}`;
  const phone = data?.student_mob_no || '';

  const message = `*Interval Learning Student Portal*

Hello! Your learning area is ready 👇

Your Current username is Student's Full Name and password is StudentName@AdmissionNo.

# Portal: ${portalLink}
# Username: ${username}
# Password: ${password}

Please login and change your password after first login.

Happy Learning :)`;

  const copyData = () => {
    navigator.clipboard.writeText(message);
  };

  const formatPhoneForWhatsApp = (rawNumber) => {
    if (!rawNumber) return '';

    // remove all non digits
    let num = rawNumber.replace(/\D/g, '');

    // remove leading 0 (common in India)
    if (num.length === 11 && num.startsWith('0')) {
      num = num.substring(1);
    }

    // if number is 10 digit → add 91
    if (num.length === 10) {
      num = '91' + num;
    }

    // if already 91XXXXXXXXXX keep it
    if (num.length === 12 && num.startsWith('91')) {
      return num;
    }

    return num;
  };

  const shareWhatsApp = () => {
    const cleanNumber = formatPhoneForWhatsApp(phone);
    if (!cleanNumber) return;

    const encoded = encodeURIComponent(message);
    window.open(`https://wa.me/${cleanNumber}?text=${encoded}`, '_blank');
  };

  return (
    <GlobalDialog
      title={'Student Portal'}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={'sm'}
      closeButton={true}
      popupButton={
        <Button
          size="small"
          onClick={() => setOpen(true)}
          disabled={crm}
          sx={{
            textTransform: 'none',
            fontWeight: 700,
            borderRadius: 2,
            px: 2,
            py: 0.6,
            color: '#fff',
            background: 'linear-gradient(135deg,#7c3aed,#a855f7,#ec4899)',
            boxShadow: '0 6px 16px rgba(139,92,246,.35)',
            transition: '0.25s',
            '&:hover': {
              background: 'linear-gradient(135deg,#7c3aed,#a855f7,#ec4899)',
              transform: 'translateY(-1px)',
              boxShadow: '0 10px 22px rgba(139,92,246,.45)',
            },
          }}
        >
          Login Details
        </Button>
      }
      content={
        <Box
          sx={{
            borderRadius: 4,
            p: { xs: 0.5, sm: 3 },
            background: 'linear-gradient(135deg, #7c3aed 0%, #8b5cf6 40%, #a855f7 70%, #ec4899 100%)',
            color: '#fff',
            position: 'relative',
            overflow: 'hidden',
            boxShadow: '0 20px 45px rgba(139,92,246,.35)',
          }}
        >
          <Box
            sx={{
              backdropFilter: 'blur(14px)',
              background: 'rgba(255,255,255,0.12)',
              border: '1px solid rgba(255,255,255,0.25)',
              borderRadius: 3,
              p: 2.5,
            }}
          >
            <Typography fontWeight={800} fontSize={18} mb={1}>
              Login Credentials
            </Typography>

            <Box
              sx={{
                mb: 2,
                mt: 1,
                px: 1.5,
                py: 1.2,
                borderRadius: 2,
                background: 'rgba(255,255,255,0.12)',
                backdropFilter: 'blur(6px)',
                overflow: 'hidden',
              }}
            >
              <Typography sx={{ fontSize: 12.8, display: 'flex', gap: 1 }}>
                ➤ <span>Username is the student's full name</span>
              </Typography>

              <Typography sx={{ fontSize: 12.8, display: 'flex', gap: 1 }}>
                ➤{' '}
                <span>
                  Password format: <b>Studentname@AdmissionNo</b>
                </span>
              </Typography>
            </Box>

            <Stack spacing={1.5}>
              <CredentialRow label="Portal Link" value={portalLink} />
              <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)' }} />
              <CredentialRow label="Username" value={username} />
              <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)' }} />
              <CredentialRow label="Password" value={password} />
            </Stack>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={3}>
              <Button
                fullWidth
                startIcon={<ContentCopyIcon />}
                onClick={copyData}
                sx={{
                  background: '#fff',
                  color: '#6d28d9',
                  fontWeight: 700,
                  '&:hover': { background: '#f3f4f6' },
                }}
              >
                Copy Details
              </Button>

              <Button
                fullWidth
                startIcon={<WhatsAppIcon />}
                onClick={shareWhatsApp}
                sx={{
                  background: '#25D366',
                  color: '#fff',
                  fontWeight: 700,
                  '&:hover': { background: '#1ebe5d' },
                }}
              >
                Share WhatsApp
              </Button>
            </Stack>
          </Box>
        </Box>
      }
    />
  );
};

const CredentialRow = ({ label, value }) => (
  <Box>
    <Typography fontSize={12} sx={{ opacity: 0.75 }}>
      {label}
    </Typography>
    <Typography fontWeight={700} fontSize={15} sx={{ wordBreak: 'break-all' }}>
      {value}
    </Typography>
  </Box>
);

export default StudentPortal;
